import React from "react";
import { ChevronDown } from "lucide-react";
import SeaBackground from "./SeaBackground";

export default function Hero() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden flex items-center justify-center"
    >
      <SeaBackground />

      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
        <div className="meander w-40 mx-auto mb-8 opacity-80">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 0L9 5L14 7L9 9L7 14L5 9L0 7L5 5L7 0Z" fill="#D4AF37"/>
          </svg>
        </div>

        <p
          className="text-gold tracking-[0.4em] text-xs md:text-sm uppercase mb-6 animate-fade-up"
          style={{ animationDelay: "0.2s", opacity: 0 }}
        >
          Restaurant · Seit Jahren in Viechtach
        </p>

        <h1
          className="font-serif text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-semibold leading-[1.05] mb-6 text-white animate-fade-up drop-shadow-[0_4px_30px_rgba(0,0,0,0.85)]"
          style={{ animationDelay: "0.4s", opacity: 0 }}
          data-testid="hero-title"
        >
          Willkommen im{" "}
          <span className="block text-gradient-gold italic drop-shadow-[0_2px_20px_rgba(0,0,0,0.8)]">Poseidon</span>
        </h1>

        <p
          className="text-base md:text-lg text-white/95 max-w-2xl mx-auto mb-10 animate-fade-up font-light drop-shadow-[0_2px_12px_rgba(0,0,0,0.9)]"
          style={{ animationDelay: "0.6s", opacity: 0 }}
          data-testid="hero-subtitle"
        >
          Authentische griechische Küche in Viechtach – mit Liebe zubereitet,
          mit Herz serviert. Tauchen Sie ein in die Aromen des Mittelmeers.
        </p>

        <div
          className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-up"
          style={{ animationDelay: "0.8s", opacity: 0 }}
        >
          <button
            onClick={() => scrollTo("speisekarte")}
            data-testid="hero-menu-button"
            className="px-8 py-4 rounded-full bg-gold text-black font-medium tracking-wide hover:bg-gold-soft transition-all duration-300 hover:scale-[1.03] shadow-2xl shadow-gold/30"
          >
            Speisekarte ansehen
          </button>
          <button
            onClick={() => scrollTo("reservierung")}
            data-testid="hero-reserve-button"
            className="px-8 py-4 rounded-full border border-gold/50 text-gold hover:bg-gold/10 transition-all duration-300 hover:scale-[1.03]"
          >
            Tisch reservieren
          </button>
        </div>
      </div>

      <button
        onClick={() => scrollTo("ueber-uns")}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 text-gold/70 hover:text-gold animate-float-slow"
        aria-label="Nach unten scrollen"
        data-testid="scroll-down-arrow"
      >
        <ChevronDown size={32} />
      </button>
    </section>
  );
}
